'use client';

import { IBranch } from '@/_types';
import { getWhereToGoHref } from '@/_lib/brand-href';
import { buildImageSrc } from '@/app/[locale]/(home)/_components/CategoriesList/utils';
import { useCustomLocale } from '@/shared/hooks/use-custom-locale';
import { Link } from '@/i18n/navigation';
import {
  AspectRatio,
  Badge,
  Box,
  Center,
  HStack,
  Stack,
  Text,
} from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { StarIcon } from '@/_assets/icon-components';

interface BranchCardProps {
  branch: IBranch;
}

const BranchCard = ({ branch }: BranchCardProps) => {
  const imageSrc = buildImageSrc(branch?.images?.[0]);
  const t = useTranslations();
  const currentLocale = useCustomLocale();
  return (
    <Stack gap={1} cursor='pointer'>
      <Link href={getWhereToGoHref(branch.shipper_id, branch.slug || branch.id)}>
        <Box position='relative'>
          {imageSrc ? (
            <AspectRatio
              ratio={2 / 1}
              maxHeight={175}
              rounded={{ base: '16px', lg: '24px' }}
              border='1px solid #eee'
              overflow='hidden'
            >
              <Image
                src={imageSrc}
                alt={branch.name}
                style={{
                  objectFit: 'cover',
                }}
                fill
              />
            </AspectRatio>
          ) : (
            <Box
              w='full'
              h='175px'
              rounded={24}
              bg='gray.100'
              display='flex'
              alignItems='center'
              justifyContent='center'
            >
              <Text fontSize='sm' textAlign='center'>
                {branch.name}
              </Text>
            </Box>
          )}
          <Center position='absolute' bottom='0' left='10px' w='70px' h='34px' bg='white' roundedTop='12px' gap={1}>
            <StarIcon color='#EB5A26' />
            <Text fontSize='md' color='#EB5A26' fontWeight={600}>{(branch.rating || 5)?.toFixed(1)}</Text>
          </Center>
        </Box>
        <Text mt={2} fontSize='md' lineHeight={1.2} fontWeight={600}>
          {branch.name}
        </Text>
        <Text mt={1} fontSize='sm' lineHeight={1.2} lineClamp={2}>
          {branch.address} - {branch.delivery_time} {t('time')} - {t('to_time', { time: branch.close_time })}
        </Text>
        <HStack mt={1}>{branch.shipper_tags?.map((i) => (<Badge variant="subtle" key={i.id} rounded='full' size='md'>{i.title[currentLocale]}</Badge>))}</HStack>
      </Link>
    </Stack>
  );
};

export default BranchCard;
